module.exports = (__webpack_require__(351725))("./node_modules/react-feather/dist/index.js");